module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "github-tile.9b57a49f.svg" + "?" + Date.now();